exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".embed-list-wrapper[data-v-46444a14]{width:100%;padding-bottom:10px}", ""]);

// exports
